import * as LucideIcons from "lucide-react";
import React from "react";

export default function Icon({ name, className = "w-5 h-5", ...rest }) {
  const Cmp = LucideIcons[name] || LucideIcons.Circle;
  return <Cmp className={className} {...rest} />;
}
